import { rootApi } from '../rootApi';
import {
  ChatRequest,
  ChatResponse,
  MatchResponse,
  NudgesResponse,
  OrgPromptRequest,
  OrgPromptResponse,
  OutreachRequest,
  OutreachResponse,
  StaleSettings,
} from './ai.types';

export const aiApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAiMatch: builder.query<MatchResponse, { jobId: string; limit?: number; refresh?: number }>({
      query: ({ jobId, limit = 10, refresh }) => ({
        url: '/ai/match',
        params: refresh ? { jobId, limit, refresh } : { jobId, limit },
      }),
      keepUnusedDataFor: 3600,
    }),

    postAiChat: builder.mutation<ChatResponse, ChatRequest>({
      query: (body) => ({
        url: '/ai/chat',
        method: 'POST',
        data: body,
      }),
    }),

    getAiNudges: builder.query<NudgesResponse, void>({
      query: () => ({ url: '/ai/nudges' }),
      providesTags: ['Nudges'],
    }),

    postAiOutreach: builder.mutation<OutreachResponse, OutreachRequest>({
      query: (body) => ({
        url: '/ai/outreach',
        method: 'POST',
        data: body,
      }),
    }),

    getOrgPrompt: builder.query<OrgPromptResponse, void>({
      query: () => ({ url: '/ai/org-prompt' }),
      providesTags: ['OrgPrompt'],
    }),

    putOrgPrompt: builder.mutation<{ success: boolean }, OrgPromptRequest>({
      query: (body) => ({
        url: '/ai/org-prompt',
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: ['OrgPrompt'],
    }),

    getStaleSettings: builder.query<StaleSettings, void>({
      query: () => ({ url: '/ai/stale-settings' }),
      providesTags: ['StaleSettings'],
    }),

    putStaleSettings: builder.mutation<StaleSettings, Partial<StaleSettings>>({
      query: (body) => ({
        url: '/ai/stale-settings',
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: ['StaleSettings', 'Nudges'],
    }),
  }),
});

export const {
  useGetAiMatchQuery,
  usePostAiChatMutation,
  useGetAiNudgesQuery,
  usePostAiOutreachMutation,
  useGetOrgPromptQuery,
  usePutOrgPromptMutation,
  useGetStaleSettingsQuery,
  usePutStaleSettingsMutation,
} = aiApi;
